import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccuracyStatus = /*#__PURE__*/function (AccuracyStatus) {
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_UNKNOWN"] = 0] = "ACCURACY_STATUS_UNKNOWN";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_ACCURATE"] = 1] = "ACCURACY_STATUS_ACCURATE";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_INACCURATE"] = 2] = "ACCURACY_STATUS_INACCURATE";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_NOT_AVAILABLE"] = 3] = "ACCURACY_STATUS_NOT_AVAILABLE";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_NOT_FOUND"] = 4] = "ACCURACY_STATUS_NOT_FOUND";
  return AccuracyStatus;
}(AccuracyStatus || {});
var ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency = /*#__PURE__*/function (ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency) {
  ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency[ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency["LIST_LISTING_SYNC_PRO_ADDON_IDS_RESPONSE_ADDON_INFO_BILLING_FREQUENCY_UNSPECIFIED"] = 0] = "LIST_LISTING_SYNC_PRO_ADDON_IDS_RESPONSE_ADDON_INFO_BILLING_FREQUENCY_UNSPECIFIED";
  ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency[ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency["LIST_LISTING_SYNC_PRO_ADDON_IDS_RESPONSE_ADDON_INFO_BILLING_FREQUENCY_MONTHLY"] = 1] = "LIST_LISTING_SYNC_PRO_ADDON_IDS_RESPONSE_ADDON_INFO_BILLING_FREQUENCY_MONTHLY";
  ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency[ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency["LIST_LISTING_SYNC_PRO_ADDON_IDS_RESPONSE_ADDON_INFO_BILLING_FREQUENCY_YEARLY"] = 2] = "LIST_LISTING_SYNC_PRO_ADDON_IDS_RESPONSE_ADDON_INFO_BILLING_FREQUENCY_YEARLY";
  return ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency;
}(ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency || {});
var BillingFrequency = /*#__PURE__*/function (BillingFrequency) {
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_UNSPECIFIED"] = 0] = "BILLING_FREQUENCY_UNSPECIFIED";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_MONTHLY"] = 1] = "BILLING_FREQUENCY_MONTHLY";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_YEARLY"] = 2] = "BILLING_FREQUENCY_YEARLY";
  return BillingFrequency;
}(BillingFrequency || {});
var ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode[ErrorCode["ERROR_CODE_NAME"] = 0] = "ERROR_CODE_NAME";
  ErrorCode[ErrorCode["ERROR_CODE_STREET_ADDRESS"] = 1] = "ERROR_CODE_STREET_ADDRESS";
  ErrorCode[ErrorCode["ERROR_CODE_ZIP_CODE"] = 2] = "ERROR_CODE_ZIP_CODE";
  ErrorCode[ErrorCode["ERROR_CODE_PHONE_NUMBER"] = 3] = "ERROR_CODE_PHONE_NUMBER";
  ErrorCode[ErrorCode["ERROR_CODE_WHOLE_ADDRESS"] = 4] = "ERROR_CODE_WHOLE_ADDRESS";
  ErrorCode[ErrorCode["ERROR_CODE_HOURS_OF_OPERATION"] = 5] = "ERROR_CODE_HOURS_OF_OPERATION";
  ErrorCode[ErrorCode["ERROR_CODE_CATEGORIES"] = 6] = "ERROR_CODE_CATEGORIES";
  ErrorCode[ErrorCode["ERROR_CODE_DESCRIPTION_LONG"] = 7] = "ERROR_CODE_DESCRIPTION_LONG";
  ErrorCode[ErrorCode["ERROR_CODE_DESCRIPTION_SHORT"] = 8] = "ERROR_CODE_DESCRIPTION_SHORT";
  ErrorCode[ErrorCode["ERROR_CODE_EMAIL"] = 9] = "ERROR_CODE_EMAIL";
  ErrorCode[ErrorCode["ERROR_CODE_PAYMENT_OPTIONS"] = 10] = "ERROR_CODE_PAYMENT_OPTIONS";
  ErrorCode[ErrorCode["ERROR_CODE_PHOTOS"] = 11] = "ERROR_CODE_PHOTOS";
  ErrorCode[ErrorCode["ERROR_CODE_SOCIAL_PROFILES"] = 12] = "ERROR_CODE_SOCIAL_PROFILES";
  ErrorCode[ErrorCode["ERROR_CODE_WEBSITE"] = 13] = "ERROR_CODE_WEBSITE";
  ErrorCode[ErrorCode["ERROR_CODE_NOT_FOUND"] = 14] = "ERROR_CODE_NOT_FOUND";
  ErrorCode[ErrorCode["ERROR_CODE_NOT_IN_SYNC"] = 15] = "ERROR_CODE_NOT_IN_SYNC";
  ErrorCode[ErrorCode["ERROR_CODE_DOES_NOT_SUPPORT_SERVICE_AREA_BUSINESS"] = 16] = "ERROR_CODE_DOES_NOT_SUPPORT_SERVICE_AREA_BUSINESS";
  ErrorCode[ErrorCode["ERROR_CODE_CLAIMED_BY_OTHERS"] = 17] = "ERROR_CODE_CLAIMED_BY_OTHERS";
  ErrorCode[ErrorCode["ERROR_CODE_NOT_CLAIMABLE"] = 18] = "ERROR_CODE_NOT_CLAIMABLE";
  ErrorCode[ErrorCode["ERROR_CODE_NO_ONLINE_LISTING"] = 19] = "ERROR_CODE_NO_ONLINE_LISTING";
  ErrorCode[ErrorCode["ERROR_CODE_UNHANDLED_ERROR"] = 20] = "ERROR_CODE_UNHANDLED_ERROR";
  ErrorCode[ErrorCode["ERROR_CODE_EXISTING_RELATIONSHIP"] = 21] = "ERROR_CODE_EXISTING_RELATIONSHIP";
  ErrorCode[ErrorCode["ERROR_CODE_CONTACT_SOURCE"] = 22] = "ERROR_CODE_CONTACT_SOURCE";
  ErrorCode[ErrorCode["ERROR_CODE_CHAIN_LOCATION"] = 23] = "ERROR_CODE_CHAIN_LOCATION";
  ErrorCode[ErrorCode["ERROR_CODE_UNAVAILABLE_REASON"] = 24] = "ERROR_CODE_UNAVAILABLE_REASON";
  ErrorCode[ErrorCode["ERROR_CODE_SCRAPED_DATA_URL_MISMATCH"] = 25] = "ERROR_CODE_SCRAPED_DATA_URL_MISMATCH";
  ErrorCode[ErrorCode["ERROR_CODE_CITY"] = 26] = "ERROR_CODE_CITY";
  ErrorCode[ErrorCode["ERROR_CODE_SERVICES"] = 27] = "ERROR_CODE_SERVICES";
  return ErrorCode;
}(ErrorCode || {});
var ServiceProvider = /*#__PURE__*/function (ServiceProvider) {
  ServiceProvider[ServiceProvider["SERVICE_PROVIDER_UNSPECIFIED"] = 0] = "SERVICE_PROVIDER_UNSPECIFIED";
  ServiceProvider[ServiceProvider["SERVICE_PROVIDER_PROVIDER_0"] = 1] = "SERVICE_PROVIDER_PROVIDER_0";
  ServiceProvider[ServiceProvider["SERVICE_PROVIDER_PROVIDER_1"] = 2] = "SERVICE_PROVIDER_PROVIDER_1";
  return ServiceProvider;
}(ServiceProvider || {});
var SiteType = /*#__PURE__*/function (SiteType) {
  SiteType[SiteType["SITE_TYPE_UNSPECIFIED"] = 0] = "SITE_TYPE_UNSPECIFIED";
  SiteType[SiteType["SITE_TYPE_MAP"] = 1] = "SITE_TYPE_MAP";
  SiteType[SiteType["SITE_TYPE_SOCIAL"] = 2] = "SITE_TYPE_SOCIAL";
  SiteType[SiteType["SITE_TYPE_AGGREGATOR"] = 3] = "SITE_TYPE_AGGREGATOR";
  SiteType[SiteType["SITE_TYPE_HISPANIC_SITE"] = 4] = "SITE_TYPE_HISPANIC_SITE";
  SiteType[SiteType["SITE_TYPE_APP"] = 5] = "SITE_TYPE_APP";
  SiteType[SiteType["SITE_TYPE_GPS"] = 6] = "SITE_TYPE_GPS";
  SiteType[SiteType["SITE_TYPE_DIRECTORY"] = 7] = "SITE_TYPE_DIRECTORY";
  return SiteType;
}(SiteType || {});
var StatusCode = /*#__PURE__*/function (StatusCode) {
  StatusCode[StatusCode["STATUS_CODE_UNKNOWN"] = 0] = "STATUS_CODE_UNKNOWN";
  StatusCode[StatusCode["STATUS_CODE_SYNCED"] = 1] = "STATUS_CODE_SYNCED";
  StatusCode[StatusCode["STATUS_CODE_IN_PROGRESS"] = 2] = "STATUS_CODE_IN_PROGRESS";
  StatusCode[StatusCode["STATUS_CODE_IGNORING_ERRORS"] = 3] = "STATUS_CODE_IGNORING_ERRORS";
  StatusCode[StatusCode["STATUS_CODE_SYNCING_WITH_WARNINGS"] = 4] = "STATUS_CODE_SYNCING_WITH_WARNINGS";
  StatusCode[StatusCode["STATUS_CODE_HAS_ERRORS"] = 5] = "STATUS_CODE_HAS_ERRORS";
  StatusCode[StatusCode["STATUS_CODE_SYNC_DISABLED"] = 6] = "STATUS_CODE_SYNC_DISABLED";
  StatusCode[StatusCode["STATUS_CODE_CLAIMED_BY_OTHERS"] = 7] = "STATUS_CODE_CLAIMED_BY_OTHERS";
  StatusCode[StatusCode["STATUS_CODE_DOES_NOT_SUPPORT_SERVICE_AREA_BUSINESS"] = 8] = "STATUS_CODE_DOES_NOT_SUPPORT_SERVICE_AREA_BUSINESS";
  StatusCode[StatusCode["STATUS_CODE_SUBMITTED"] = 9] = "STATUS_CODE_SUBMITTED";
  StatusCode[StatusCode["STATUS_CODE_MANUAL_UPDATE_ONLY"] = 10] = "STATUS_CODE_MANUAL_UPDATE_ONLY";
  StatusCode[StatusCode["STATUS_CODE_NOT_FOUND"] = 11] = "STATUS_CODE_NOT_FOUND";
  return StatusCode;
}(StatusCode || {});
var SyncingStatus = /*#__PURE__*/function (SyncingStatus) {
  SyncingStatus[SyncingStatus["SYNCING_STATUS_UNSPECIFIED"] = 0] = "SYNCING_STATUS_UNSPECIFIED";
  SyncingStatus[SyncingStatus["SYNCING_STATUS_SYNCING"] = 1] = "SYNCING_STATUS_SYNCING";
  SyncingStatus[SyncingStatus["SYNCING_STATUS_COMPLETELY_SYNCED"] = 2] = "SYNCING_STATUS_COMPLETELY_SYNCED";
  return SyncingStatus;
}(SyncingStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountFilters {
  static fromProto(proto) {
    let m = new AccountFilters();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = enumStringToValue(ServiceProvider, proto.serviceProvider);
    }
    if (proto.errorCodes) {
      m.errorCodes = proto.errorCodes.map(v => enumStringToValue(ErrorCode, v));
    }
    if (proto.syncingStatus) {
      m.syncingStatus = enumStringToValue(SyncingStatus, proto.syncingStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.serviceProvider !== 'undefined') {
      toReturn['serviceProvider'] = this.serviceProvider;
    }
    if (typeof this.errorCodes !== 'undefined') {
      toReturn['errorCodes'] = this.errorCodes;
    }
    if (typeof this.syncingStatus !== 'undefined') {
      toReturn['syncingStatus'] = this.syncingStatus;
    }
    return toReturn;
  }
}
class AccountListingStatuses {
  static fromProto(proto) {
    let m = new AccountListingStatuses();
    m = Object.assign(m, proto);
    if (proto.sourceStatuses) {
      m.sourceStatuses = proto.sourceStatuses.map(SourceStatus.fromProto);
    }
    if (proto.statusDate) {
      m.statusDate = new Date(proto.statusDate);
    }
    if (proto.businessUpdated) {
      m.businessUpdated = new Date(proto.businessUpdated);
    }
    if (proto.sourceData) {
      m.sourceData = SourceData.fromProto(proto.sourceData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.sourceStatuses !== 'undefined' && this.sourceStatuses !== null) {
      toReturn['sourceStatuses'] = 'toApiJson' in this.sourceStatuses ? this.sourceStatuses.toApiJson() : this.sourceStatuses;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.statusDate !== 'undefined' && this.statusDate !== null) {
      toReturn['statusDate'] = 'toApiJson' in this.statusDate ? this.statusDate.toApiJson() : this.statusDate;
    }
    if (typeof this.businessUpdated !== 'undefined' && this.businessUpdated !== null) {
      toReturn['businessUpdated'] = 'toApiJson' in this.businessUpdated ? this.businessUpdated.toApiJson() : this.businessUpdated;
    }
    if (typeof this.sourceData !== 'undefined' && this.sourceData !== null) {
      toReturn['sourceData'] = 'toApiJson' in this.sourceData ? this.sourceData.toApiJson() : this.sourceData;
    }
    return toReturn;
  }
}
class ActivateListingSyncProRequest {
  static fromProto(proto) {
    let m = new ActivateListingSyncProRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class ListListingSyncProAddonIdsResponseAddonInfo {
  static fromProto(proto) {
    let m = new ListListingSyncProAddonIdsResponseAddonInfo();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue(ServiceProvider, proto.provider);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue(ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency, proto.billingFrequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.isDiscounted !== 'undefined') {
      toReturn['isDiscounted'] = this.isDiscounted;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    return toReturn;
  }
}
class ListListingSyncProAddonIdsResponseAddonInfoEntry {
  static fromProto(proto) {
    let m = new ListListingSyncProAddonIdsResponseAddonInfoEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ListListingSyncProAddonIdsResponseAddonInfo.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class AnchorData {
  static fromProto(proto) {
    let m = new AnchorData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    return toReturn;
  }
}
class AnchorDataMatches {
  static fromProto(proto) {
    let m = new AnchorDataMatches();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    return toReturn;
  }
}
class Citation {
  static fromProto(proto) {
    let m = new Citation();
    m = Object.assign(m, proto);
    if (proto.listings) {
      m.listings = proto.listings.map(CitationListing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.listings !== 'undefined' && this.listings !== null) {
      toReturn['listings'] = 'toApiJson' in this.listings ? this.listings.toApiJson() : this.listings;
    }
    return toReturn;
  }
}
class CitationListing {
  static fromProto(proto) {
    let m = new CitationListing();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class CollectStatsRequest {
  static fromProto(proto) {
    let m = new CollectStatsRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = enumStringToValue(ServiceProvider, proto.serviceProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.serviceProvider !== 'undefined') {
      toReturn['serviceProvider'] = this.serviceProvider;
    }
    if (typeof this.serviceAreaBusiness !== 'undefined') {
      toReturn['serviceAreaBusiness'] = this.serviceAreaBusiness;
    }
    if (typeof this.refreshListings !== 'undefined') {
      toReturn['refreshListings'] = this.refreshListings;
    }
    if (typeof this.validateCsListingSubmissions !== 'undefined') {
      toReturn['validateCsListingSubmissions'] = this.validateCsListingSubmissions;
    }
    return toReturn;
  }
}
class CreateListingSyncProProviderSourceDataRequest {
  static fromProto(proto) {
    let m = new CreateListingSyncProProviderSourceDataRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = enumStringToValue(ServiceProvider, proto.serviceProvider);
    }
    if (proto.sourceData) {
      m.sourceData = ListingSyncProProviderSourceData.fromProto(proto.sourceData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.providerSpecificId !== 'undefined') {
      toReturn['providerSpecificId'] = this.providerSpecificId;
    }
    if (typeof this.serviceProvider !== 'undefined') {
      toReturn['serviceProvider'] = this.serviceProvider;
    }
    if (typeof this.sourceData !== 'undefined' && this.sourceData !== null) {
      toReturn['sourceData'] = 'toApiJson' in this.sourceData ? this.sourceData.toApiJson() : this.sourceData;
    }
    return toReturn;
  }
}
class CreateListingSyncProSourceRequest {
  static fromProto(proto) {
    let m = new CreateListingSyncProSourceRequest();
    m = Object.assign(m, proto);
    if (proto.sourceInfo) {
      m.sourceInfo = SourceInfo.fromProto(proto.sourceInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceInfo !== 'undefined' && this.sourceInfo !== null) {
      toReturn['sourceInfo'] = 'toApiJson' in this.sourceInfo ? this.sourceInfo.toApiJson() : this.sourceInfo;
    }
    return toReturn;
  }
}
class CreateListingSyncProSourceResponse {
  static fromProto(proto) {
    let m = new CreateListingSyncProSourceResponse();
    m = Object.assign(m, proto);
    if (proto.sourceInfo) {
      m.sourceInfo = SourceInfo.fromProto(proto.sourceInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceInfo !== 'undefined' && this.sourceInfo !== null) {
      toReturn['sourceInfo'] = 'toApiJson' in this.sourceInfo ? this.sourceInfo.toApiJson() : this.sourceInfo;
    }
    return toReturn;
  }
}
class DeactivateListingSyncProRequest {
  static fromProto(proto) {
    let m = new DeactivateListingSyncProRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class DeleteListingSyncProProviderSourceRequest {
  static fromProto(proto) {
    let m = new DeleteListingSyncProProviderSourceRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = enumStringToValue(ServiceProvider, proto.serviceProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.providerSpecificId !== 'undefined') {
      toReturn['providerSpecificId'] = this.providerSpecificId;
    }
    if (typeof this.serviceProvider !== 'undefined') {
      toReturn['serviceProvider'] = this.serviceProvider;
    }
    return toReturn;
  }
}
class DeleteStatsRequest {
  static fromProto(proto) {
    let m = new DeleteStatsRequest();
    m = Object.assign(m, proto);
    if (proto.fromDate) {
      m.fromDate = new Date(proto.fromDate);
    }
    if (proto.toDate) {
      m.toDate = new Date(proto.toDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fromDate !== 'undefined' && this.fromDate !== null) {
      toReturn['fromDate'] = 'toApiJson' in this.fromDate ? this.fromDate.toApiJson() : this.fromDate;
    }
    if (typeof this.toDate !== 'undefined' && this.toDate !== null) {
      toReturn['toDate'] = 'toApiJson' in this.toDate ? this.toDate.toApiJson() : this.toDate;
    }
    if (typeof this.sources !== 'undefined') {
      toReturn['sources'] = this.sources;
    }
    return toReturn;
  }
}
class Errors {
  static fromProto(proto) {
    let m = new Errors();
    m = Object.assign(m, proto);
    if (proto.errorCode) {
      m.errorCode = enumStringToValue(ErrorCode, proto.errorCode);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errorCode !== 'undefined') {
      toReturn['errorCode'] = this.errorCode;
    }
    if (typeof this.errorDetails !== 'undefined') {
      toReturn['errorDetails'] = this.errorDetails;
    }
    return toReturn;
  }
}
class GetAvailableProvidersForPartnerRequest {
  static fromProto(proto) {
    let m = new GetAvailableProvidersForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetAvailableProvidersForPartnerResponse {
  static fromProto(proto) {
    let m = new GetAvailableProvidersForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.serviceProviders) {
      m.serviceProviders = proto.serviceProviders.map(v => enumStringToValue(ServiceProvider, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviders !== 'undefined') {
      toReturn['serviceProviders'] = this.serviceProviders;
    }
    return toReturn;
  }
}
class GetCitationDataRequest {
  static fromProto(proto) {
    let m = new GetCitationDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetCitationDataResponse {
  static fromProto(proto) {
    let m = new GetCitationDataResponse();
    m = Object.assign(m, proto);
    if (proto.citationCount) {
      m.citationCount = parseInt(proto.citationCount, 10);
    }
    if (proto.initialCitationCount) {
      m.initialCitationCount = parseInt(proto.initialCitationCount, 10);
    }
    if (proto.historicalCitationsSeries) {
      m.historicalCitationsSeries = proto.historicalCitationsSeries.map(HistoricalCitationsDataPoint.fromProto);
    }
    if (proto.citations) {
      m.citations = proto.citations.map(Citation.fromProto);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.citationPercentGrowth) {
      m.citationPercentGrowth = parseInt(proto.citationPercentGrowth, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.citationCount !== 'undefined') {
      toReturn['citationCount'] = this.citationCount;
    }
    if (typeof this.initialCitationCount !== 'undefined') {
      toReturn['initialCitationCount'] = this.initialCitationCount;
    }
    if (typeof this.historicalCitationsSeries !== 'undefined' && this.historicalCitationsSeries !== null) {
      toReturn['historicalCitationsSeries'] = 'toApiJson' in this.historicalCitationsSeries ? this.historicalCitationsSeries.toApiJson() : this.historicalCitationsSeries;
    }
    if (typeof this.citations !== 'undefined' && this.citations !== null) {
      toReturn['citations'] = 'toApiJson' in this.citations ? this.citations.toApiJson() : this.citations;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.citationPercentGrowth !== 'undefined') {
      toReturn['citationPercentGrowth'] = this.citationPercentGrowth;
    }
    return toReturn;
  }
}
class GetListingDataForATimePeriodRequest {
  static fromProto(proto) {
    let m = new GetListingDataForATimePeriodRequest();
    m = Object.assign(m, proto);
    if (proto.begin) {
      m.begin = new Date(proto.begin);
    }
    if (proto.recent) {
      m.recent = new Date(proto.recent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.begin !== 'undefined' && this.begin !== null) {
      toReturn['begin'] = 'toApiJson' in this.begin ? this.begin.toApiJson() : this.begin;
    }
    if (typeof this.recent !== 'undefined' && this.recent !== null) {
      toReturn['recent'] = 'toApiJson' in this.recent ? this.recent.toApiJson() : this.recent;
    }
    return toReturn;
  }
}
class GetListingDataRequest {
  static fromProto(proto) {
    let m = new GetListingDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetListingDataResponse {
  static fromProto(proto) {
    let m = new GetListingDataResponse();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue(ServiceProvider, proto.provider);
    }
    if (proto.scores) {
      m.scores = ScoreData.fromProto(proto.scores);
    }
    if (proto.anchorData) {
      m.anchorData = AnchorData.fromProto(proto.anchorData);
    }
    if (proto.sources) {
      m.sources = proto.sources.map(SourceTableData.fromProto);
    }
    if (proto.totalSources) {
      m.totalSources = parseInt(proto.totalSources, 10);
    }
    if (proto.totalAcceptedSources) {
      m.totalAcceptedSources = parseInt(proto.totalAcceptedSources, 10);
    }
    if (proto.totalAccuracyGoodSources) {
      m.totalAccuracyGoodSources = parseInt(proto.totalAccuracyGoodSources, 10);
    }
    if (proto.totalManualSyncOnlySources) {
      m.totalManualSyncOnlySources = parseInt(proto.totalManualSyncOnlySources, 10);
    }
    if (proto.totalAccuracySources) {
      m.totalAccuracySources = parseInt(proto.totalAccuracySources, 10);
    }
    if (proto.totalPossibleErrors) {
      m.totalPossibleErrors = parseInt(proto.totalPossibleErrors, 10);
    }
    if (proto.totalNotFound) {
      m.totalNotFound = parseInt(proto.totalNotFound, 10);
    }
    if (proto.totalInProgressSources) {
      m.totalInProgressSources = parseInt(proto.totalInProgressSources, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.lspActive !== 'undefined') {
      toReturn['lspActive'] = this.lspActive;
    }
    if (typeof this.ldActive !== 'undefined') {
      toReturn['ldActive'] = this.ldActive;
    }
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.scores !== 'undefined' && this.scores !== null) {
      toReturn['scores'] = 'toApiJson' in this.scores ? this.scores.toApiJson() : this.scores;
    }
    if (typeof this.anchorData !== 'undefined' && this.anchorData !== null) {
      toReturn['anchorData'] = 'toApiJson' in this.anchorData ? this.anchorData.toApiJson() : this.anchorData;
    }
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    if (typeof this.totalSources !== 'undefined') {
      toReturn['totalSources'] = this.totalSources;
    }
    if (typeof this.totalAcceptedSources !== 'undefined') {
      toReturn['totalAcceptedSources'] = this.totalAcceptedSources;
    }
    if (typeof this.totalAccuracyGoodSources !== 'undefined') {
      toReturn['totalAccuracyGoodSources'] = this.totalAccuracyGoodSources;
    }
    if (typeof this.totalManualSyncOnlySources !== 'undefined') {
      toReturn['totalManualSyncOnlySources'] = this.totalManualSyncOnlySources;
    }
    if (typeof this.totalAccuracySources !== 'undefined') {
      toReturn['totalAccuracySources'] = this.totalAccuracySources;
    }
    if (typeof this.percentageAccuracyGoodSources !== 'undefined') {
      toReturn['percentageAccuracyGoodSources'] = this.percentageAccuracyGoodSources;
    }
    if (typeof this.totalPossibleErrors !== 'undefined') {
      toReturn['totalPossibleErrors'] = this.totalPossibleErrors;
    }
    if (typeof this.totalNotFound !== 'undefined') {
      toReturn['totalNotFound'] = this.totalNotFound;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.totalInProgressSources !== 'undefined') {
      toReturn['totalInProgressSources'] = this.totalInProgressSources;
    }
    if (typeof this.lspUpgradePathEnabled !== 'undefined') {
      toReturn['lspUpgradePathEnabled'] = this.lspUpgradePathEnabled;
    }
    if (typeof this.localSeoProUpgradePathEnabled !== 'undefined') {
      toReturn['localSeoProUpgradePathEnabled'] = this.localSeoProUpgradePathEnabled;
    }
    return toReturn;
  }
}
class GetListingSyncProAddonIdRequest {
  static fromProto(proto) {
    let m = new GetListingSyncProAddonIdRequest();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue(ServiceProvider, proto.provider);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue(BillingFrequency, proto.billingFrequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    return toReturn;
  }
}
class GetListingSyncProAddonIdResponse {
  static fromProto(proto) {
    let m = new GetListingSyncProAddonIdResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.preferencesOverriddenReasons !== 'undefined') {
      toReturn['preferencesOverriddenReasons'] = this.preferencesOverriddenReasons;
    }
    return toReturn;
  }
}
class GetListingSyncProProviderSourcesDataRequest {
  static fromProto(proto) {
    let m = new GetListingSyncProProviderSourcesDataRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = enumStringToValue(ServiceProvider, proto.serviceProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProvider !== 'undefined') {
      toReturn['serviceProvider'] = this.serviceProvider;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetListingSyncProProviderSourcesDataResponse {
  static fromProto(proto) {
    let m = new GetListingSyncProProviderSourcesDataResponse();
    m = Object.assign(m, proto);
    if (proto.sourceData) {
      m.sourceData = Object.keys(proto.sourceData).reduce((obj, k) => {
        obj[k] = ListingSyncProProviderSourceData.fromProto(proto.sourceData[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceData !== 'undefined' && this.sourceData !== null) {
      toReturn['sourceData'] = 'toApiJson' in this.sourceData ? this.sourceData.toApiJson() : this.sourceData;
    }
    return toReturn;
  }
}
class GetProviderSourcesForBusinessRequest {
  static fromProto(proto) {
    let m = new GetProviderSourcesForBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetProviderSourcesForBusinessResponse {
  static fromProto(proto) {
    let m = new GetProviderSourcesForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue(ServiceProvider, proto.provider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.sourceNames !== 'undefined') {
      toReturn['sourceNames'] = this.sourceNames;
    }
    return toReturn;
  }
}
class GetScrapedSourceStatusesRequest {
  static fromProto(proto) {
    let m = new GetScrapedSourceStatusesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetScrapedSourceStatusesResponse {
  static fromProto(proto) {
    let m = new GetScrapedSourceStatusesResponse();
    m = Object.assign(m, proto);
    if (proto.sourceStatuses) {
      m.sourceStatuses = proto.sourceStatuses.map(SourceStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceStatuses !== 'undefined' && this.sourceStatuses !== null) {
      toReturn['sourceStatuses'] = 'toApiJson' in this.sourceStatuses ? this.sourceStatuses.toApiJson() : this.sourceStatuses;
    }
    return toReturn;
  }
}
class GetSelectedSocialServicesRequest {
  static fromProto(proto) {
    let m = new GetSelectedSocialServicesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetSelectedSocialServicesResponse {
  static fromProto(proto) {
    let m = new GetSelectedSocialServicesResponse();
    m = Object.assign(m, proto);
    if (proto.selectedServices) {
      m.selectedServices = proto.selectedServices.map(SelectedSocialService.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.selectedServices !== 'undefined' && this.selectedServices !== null) {
      toReturn['selectedServices'] = 'toApiJson' in this.selectedServices ? this.selectedServices.toApiJson() : this.selectedServices;
    }
    return toReturn;
  }
}
class HistoricalCitationsDataPoint {
  static fromProto(proto) {
    let m = new HistoricalCitationsDataPoint();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class HistoricalScore {
  static fromProto(proto) {
    let m = new HistoricalScore();
    m = Object.assign(m, proto);
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    return toReturn;
  }
}
class IsListingSyncProActiveRequest {
  static fromProto(proto) {
    let m = new IsListingSyncProActiveRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class IsListingSyncProActiveResponse {
  static fromProto(proto) {
    let m = new IsListingSyncProActiveResponse();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue(ServiceProvider, proto.provider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    return toReturn;
  }
}
class ListListingSyncProAddonIdsRequest {
  static fromProto(proto) {
    let m = new ListListingSyncProAddonIdsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ListListingSyncProAddonIdsResponse {
  static fromProto(proto) {
    let m = new ListListingSyncProAddonIdsResponse();
    m = Object.assign(m, proto);
    if (proto.addonInfo) {
      m.addonInfo = Object.keys(proto.addonInfo).reduce((obj, k) => {
        obj[k] = ListListingSyncProAddonIdsResponseAddonInfo.fromProto(proto.addonInfo[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonIds !== 'undefined') {
      toReturn['addonIds'] = this.addonIds;
    }
    if (typeof this.addonInfo !== 'undefined' && this.addonInfo !== null) {
      toReturn['addonInfo'] = 'toApiJson' in this.addonInfo ? this.addonInfo.toApiJson() : this.addonInfo;
    }
    return toReturn;
  }
}
class ListListingSyncProSourcesRequest {
  static fromProto(proto) {
    let m = new ListListingSyncProSourcesRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProviders) {
      m.serviceProviders = proto.serviceProviders.map(v => enumStringToValue(ServiceProvider, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviders !== 'undefined') {
      toReturn['serviceProviders'] = this.serviceProviders;
    }
    return toReturn;
  }
}
class ListListingSyncProSourcesResponse {
  static fromProto(proto) {
    let m = new ListListingSyncProSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = Object.keys(proto.sources).reduce((obj, k) => {
        obj[k] = SourceInfo.fromProto(proto.sources[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    return toReturn;
  }
}
class ListStatusesByBusinessRequest {
  static fromProto(proto) {
    let m = new ListStatusesByBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListStatusesByBusinessResponse {
  static fromProto(proto) {
    let m = new ListStatusesByBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.sourceStatuses) {
      m.sourceStatuses = proto.sourceStatuses.map(SourceStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceStatuses !== 'undefined' && this.sourceStatuses !== null) {
      toReturn['sourceStatuses'] = 'toApiJson' in this.sourceStatuses ? this.sourceStatuses.toApiJson() : this.sourceStatuses;
    }
    return toReturn;
  }
}
class ListStatusesByPartnerRequest {
  static fromProto(proto) {
    let m = new ListStatusesByPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = AccountFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListStatusesByPartnerResponse {
  static fromProto(proto) {
    let m = new ListStatusesByPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.lspData) {
      m.lspData = proto.lspData.map(AccountListingStatuses.fromProto);
    }
    if (proto.pagingData) {
      m.pagingData = PagedResponseMetadata.fromProto(proto.pagingData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lspData !== 'undefined' && this.lspData !== null) {
      toReturn['lspData'] = 'toApiJson' in this.lspData ? this.lspData.toApiJson() : this.lspData;
    }
    if (typeof this.pagingData !== 'undefined' && this.pagingData !== null) {
      toReturn['pagingData'] = 'toApiJson' in this.pagingData ? this.pagingData.toApiJson() : this.pagingData;
    }
    return toReturn;
  }
}
class ListingSyncProProviderSourceData {
  static fromProto(proto) {
    let m = new ListingSyncProProviderSourceData();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(SiteType, proto.type);
    }
    if (proto.popularity) {
      m.popularity = parseInt(proto.popularity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.popularity !== 'undefined') {
      toReturn['popularity'] = this.popularity;
    }
    if (typeof this.whitelistedPartnerIds !== 'undefined') {
      toReturn['whitelistedPartnerIds'] = this.whitelistedPartnerIds;
    }
    return toReturn;
  }
}
class ProcessListingSyncProMarketplaceActivationRequestOrderFormDataEntry {
  static fromProto(proto) {
    let m = new ProcessListingSyncProMarketplaceActivationRequestOrderFormDataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ProcessListingSyncProMarketplaceActivationRequest {
  static fromProto(proto) {
    let m = new ProcessListingSyncProMarketplaceActivationRequest();
    m = Object.assign(m, proto);
    if (proto.orderFormData) {
      m.orderFormData = Object.keys(proto.orderFormData).reduce((obj, k) => {
        obj[k] = proto.orderFormData[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.orderFormData !== 'undefined' && this.orderFormData !== null) {
      toReturn['orderFormData'] = 'toApiJson' in this.orderFormData ? this.orderFormData.toApiJson() : this.orderFormData;
    }
    if (typeof this.dryRun !== 'undefined') {
      toReturn['dryRun'] = this.dryRun;
    }
    return toReturn;
  }
}
class SourceInfoProviderSpecificIdsEntry {
  static fromProto(proto) {
    let m = new SourceInfoProviderSpecificIdsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ScoreData {
  static fromProto(proto) {
    let m = new ScoreData();
    m = Object.assign(m, proto);
    if (proto.totalScore) {
      m.totalScore = parseInt(proto.totalScore, 10);
    }
    if (proto.maxListingScore) {
      m.maxListingScore = parseInt(proto.maxListingScore, 10);
    }
    if (proto.listingScore) {
      m.listingScore = parseInt(proto.listingScore, 10);
    }
    if (proto.industryAverage) {
      m.industryAverage = parseInt(proto.industryAverage, 10);
    }
    if (proto.industryAveragePercentile) {
      m.industryAveragePercentile = parseInt(proto.industryAveragePercentile, 10);
    }
    if (proto.ninetyFifthPercentile) {
      m.ninetyFifthPercentile = parseInt(proto.ninetyFifthPercentile, 10);
    }
    if (proto.businessPercentile) {
      m.businessPercentile = parseInt(proto.businessPercentile, 10);
    }
    if (proto.initialBusinessPercentile) {
      m.initialBusinessPercentile = parseInt(proto.initialBusinessPercentile, 10);
    }
    if (proto.listingScoreHistory) {
      m.listingScoreHistory = proto.listingScoreHistory.map(HistoricalScore.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalScore !== 'undefined') {
      toReturn['totalScore'] = this.totalScore;
    }
    if (typeof this.maxListingScore !== 'undefined') {
      toReturn['maxListingScore'] = this.maxListingScore;
    }
    if (typeof this.listingScore !== 'undefined') {
      toReturn['listingScore'] = this.listingScore;
    }
    if (typeof this.industryAverage !== 'undefined') {
      toReturn['industryAverage'] = this.industryAverage;
    }
    if (typeof this.industryAveragePercentile !== 'undefined') {
      toReturn['industryAveragePercentile'] = this.industryAveragePercentile;
    }
    if (typeof this.ninetyFifthPercentile !== 'undefined') {
      toReturn['ninetyFifthPercentile'] = this.ninetyFifthPercentile;
    }
    if (typeof this.businessPercentile !== 'undefined') {
      toReturn['businessPercentile'] = this.businessPercentile;
    }
    if (typeof this.initialBusinessPercentile !== 'undefined') {
      toReturn['initialBusinessPercentile'] = this.initialBusinessPercentile;
    }
    if (typeof this.listingScoreHistory !== 'undefined' && this.listingScoreHistory !== null) {
      toReturn['listingScoreHistory'] = 'toApiJson' in this.listingScoreHistory ? this.listingScoreHistory.toApiJson() : this.listingScoreHistory;
    }
    return toReturn;
  }
}
class SelectedSocialService {
  static fromProto(proto) {
    let m = new SelectedSocialService();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.ssid !== 'undefined') {
      toReturn['ssid'] = this.ssid;
    }
    return toReturn;
  }
}
class SetSelectedSocialServiceRequest {
  static fromProto(proto) {
    let m = new SetSelectedSocialServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.ssid !== 'undefined') {
      toReturn['ssid'] = this.ssid;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    return toReturn;
  }
}
class SetSelectedSocialServiceResponse {
  static fromProto(proto) {
    let m = new SetSelectedSocialServiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errorMsg !== 'undefined') {
      toReturn['errorMsg'] = this.errorMsg;
    }
    if (typeof this.successful !== 'undefined') {
      toReturn['successful'] = this.successful;
    }
    return toReturn;
  }
}
class SourceAccuracy {
  static fromProto(proto) {
    let m = new SourceAccuracy();
    m = Object.assign(m, proto);
    if (proto.anchorData) {
      m.anchorData = AnchorData.fromProto(proto.anchorData);
    }
    if (proto.anchorDataMatches) {
      m.anchorDataMatches = AnchorDataMatches.fromProto(proto.anchorDataMatches);
    }
    if (proto.status) {
      m.status = enumStringToValue(AccuracyStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.anchorData !== 'undefined' && this.anchorData !== null) {
      toReturn['anchorData'] = 'toApiJson' in this.anchorData ? this.anchorData.toApiJson() : this.anchorData;
    }
    if (typeof this.anchorDataMatches !== 'undefined' && this.anchorDataMatches !== null) {
      toReturn['anchorDataMatches'] = 'toApiJson' in this.anchorDataMatches ? this.anchorDataMatches.toApiJson() : this.anchorDataMatches;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class SourceData {
  static fromProto(proto) {
    let m = new SourceData();
    m = Object.assign(m, proto);
    if (proto.syncedSources) {
      m.syncedSources = parseInt(proto.syncedSources, 10);
    }
    if (proto.totalSources) {
      m.totalSources = parseInt(proto.totalSources, 10);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(v => enumStringToValue(ErrorCode, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.syncedSources !== 'undefined') {
      toReturn['syncedSources'] = this.syncedSources;
    }
    if (typeof this.totalSources !== 'undefined') {
      toReturn['totalSources'] = this.totalSources;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    return toReturn;
  }
}
class GetListingSyncProProviderSourcesDataResponseSourceDataEntry {
  static fromProto(proto) {
    let m = new GetListingSyncProProviderSourcesDataResponseSourceDataEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ListingSyncProProviderSourceData.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class SourceInfo {
  static fromProto(proto) {
    let m = new SourceInfo();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.serviceProviders) {
      m.serviceProviders = proto.serviceProviders.map(v => enumStringToValue(ServiceProvider, v));
    }
    if (proto.providerSpecificIds) {
      m.providerSpecificIds = Object.keys(proto.providerSpecificIds).reduce((obj, k) => {
        obj[k] = proto.providerSpecificIds[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.serviceProviders !== 'undefined') {
      toReturn['serviceProviders'] = this.serviceProviders;
    }
    if (typeof this.providerSpecificIds !== 'undefined' && this.providerSpecificIds !== null) {
      toReturn['providerSpecificIds'] = 'toApiJson' in this.providerSpecificIds ? this.providerSpecificIds.toApiJson() : this.providerSpecificIds;
    }
    return toReturn;
  }
}
class SourceStatus {
  static fromProto(proto) {
    let m = new SourceStatus();
    m = Object.assign(m, proto);
    if (proto.statusCode) {
      m.statusCode = enumStringToValue(StatusCode, proto.statusCode);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(Errors.fromProto);
    }
    if (proto.warnings) {
      m.warnings = proto.warnings.map(Errors.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.statusCode !== 'undefined') {
      toReturn['statusCode'] = this.statusCode;
    }
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.warnings !== 'undefined' && this.warnings !== null) {
      toReturn['warnings'] = 'toApiJson' in this.warnings ? this.warnings.toApiJson() : this.warnings;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class SourceTableData {
  static fromProto(proto) {
    let m = new SourceTableData();
    m = Object.assign(m, proto);
    if (proto.popularity) {
      m.popularity = parseInt(proto.popularity, 10);
    }
    if (proto.type) {
      m.type = enumStringToValue(SiteType, proto.type);
    }
    if (proto.provider) {
      m.provider = enumStringToValue(ServiceProvider, proto.provider);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.syncStatus) {
      m.syncStatus = enumStringToValue(StatusCode, proto.syncStatus);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    if (proto.maxScore) {
      m.maxScore = parseInt(proto.maxScore, 10);
    }
    if (proto.errorDetails) {
      m.errorDetails = proto.errorDetails.map(Errors.fromProto);
    }
    if (proto.warningDetails) {
      m.warningDetails = proto.warningDetails.map(Errors.fromProto);
    }
    if (proto.accuracy) {
      m.accuracy = SourceAccuracy.fromProto(proto.accuracy);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.popularity !== 'undefined') {
      toReturn['popularity'] = this.popularity;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.providerSourceId !== 'undefined') {
      toReturn['providerSourceId'] = this.providerSourceId;
    }
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.isDirectlySubmittedSource !== 'undefined') {
      toReturn['isDirectlySubmittedSource'] = this.isDirectlySubmittedSource;
    }
    if (typeof this.isLdSource !== 'undefined') {
      toReturn['isLdSource'] = this.isLdSource;
    }
    if (typeof this.directSubmissionActive !== 'undefined') {
      toReturn['directSubmissionActive'] = this.directSubmissionActive;
    }
    if (typeof this.syncStatus !== 'undefined') {
      toReturn['syncStatus'] = this.syncStatus;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.maxScore !== 'undefined') {
      toReturn['maxScore'] = this.maxScore;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.errorDetails !== 'undefined' && this.errorDetails !== null) {
      toReturn['errorDetails'] = 'toApiJson' in this.errorDetails ? this.errorDetails.toApiJson() : this.errorDetails;
    }
    if (typeof this.warningDetails !== 'undefined' && this.warningDetails !== null) {
      toReturn['warningDetails'] = 'toApiJson' in this.warningDetails ? this.warningDetails.toApiJson() : this.warningDetails;
    }
    if (typeof this.accuracy !== 'undefined' && this.accuracy !== null) {
      toReturn['accuracy'] = 'toApiJson' in this.accuracy ? this.accuracy.toApiJson() : this.accuracy;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    if (typeof this.connectLink !== 'undefined') {
      toReturn['connectLink'] = this.connectLink;
    }
    if (typeof this.disconnectLink !== 'undefined') {
      toReturn['disconnectLink'] = this.disconnectLink;
    }
    if (typeof this.ssid !== 'undefined') {
      toReturn['ssid'] = this.ssid;
    }
    if (typeof this.updateSyncLink !== 'undefined') {
      toReturn['updateSyncLink'] = this.updateSyncLink;
    }
    if (typeof this.selectedSocialService !== 'undefined') {
      toReturn['selectedSocialService'] = this.selectedSocialService;
    }
    if (typeof this.socialServiceName !== 'undefined') {
      toReturn['socialServiceName'] = this.socialServiceName;
    }
    if (typeof this.serviceType !== 'undefined') {
      toReturn['serviceType'] = this.serviceType;
    }
    if (typeof this.serviceUserId !== 'undefined') {
      toReturn['serviceUserId'] = this.serviceUserId;
    }
    if (typeof this.clientTags !== 'undefined') {
      toReturn['clientTags'] = this.clientTags;
    }
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    return toReturn;
  }
}
class ListListingSyncProSourcesResponseSourcesEntry {
  static fromProto(proto) {
    let m = new ListListingSyncProSourcesResponseSourcesEntry();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = parseInt(proto.key, 10);
    }
    if (proto.value) {
      m.value = SourceInfo.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'listing-sync-pro-api.vendasta-local.com',
  'test': '',
  'demo': 'listing-sync-pro-api-demo.apigateway.co',
  'prod': 'listing-sync-pro-api-prod.apigateway.co',
  'production': 'listing-sync-pro-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ListingSyncProApiService = /*#__PURE__*/(() => {
  class ListingSyncProApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    debouncedTriggerStatsCollection(r) {
      const request = r.toApiJson ? r : new CollectStatsRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/DebouncedTriggerStatsCollection", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    triggerStatsCollection(r) {
      const request = r.toApiJson ? r : new CollectStatsRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/TriggerStatsCollection", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listStatusesByPartner(r) {
      const request = r.toApiJson ? r : new ListStatusesByPartnerRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/ListStatusesByPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListStatusesByPartnerResponse.fromProto(resp)));
    }
    listStatusesByBusiness(r) {
      const request = r.toApiJson ? r : new ListStatusesByBusinessRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/ListStatusesByBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListStatusesByBusinessResponse.fromProto(resp)));
    }
    deleteStats(r) {
      const request = r.toApiJson ? r : new DeleteStatsRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/DeleteStats", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createListingSyncProSource(r) {
      const request = r.toApiJson ? r : new CreateListingSyncProSourceRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/CreateListingSyncProSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateListingSyncProSourceResponse.fromProto(resp)));
    }
    listListingSyncProSources(r) {
      const request = r.toApiJson ? r : new ListListingSyncProSourcesRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/ListListingSyncProSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListListingSyncProSourcesResponse.fromProto(resp)));
    }
    getAvailableProvidersForPartner(r) {
      const request = r.toApiJson ? r : new GetAvailableProvidersForPartnerRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetAvailableProvidersForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableProvidersForPartnerResponse.fromProto(resp)));
    }
    listListingSyncProAddonIds(r) {
      const request = r.toApiJson ? r : new ListListingSyncProAddonIdsRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/ListListingSyncProAddonIds", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListListingSyncProAddonIdsResponse.fromProto(resp)));
    }
    activateListingSyncPro(r) {
      const request = r.toApiJson ? r : new ActivateListingSyncProRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/ActivateListingSyncPro", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    processListingSyncProMarketplaceActivation(r) {
      const request = r.toApiJson ? r : new ProcessListingSyncProMarketplaceActivationRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/ProcessListingSyncProMarketplaceActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deactivateListingSyncPro(r) {
      const request = r.toApiJson ? r : new DeactivateListingSyncProRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/DeactivateListingSyncPro", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isListingSyncProActiveForAccount(r) {
      const request = r.toApiJson ? r : new IsListingSyncProActiveRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/IsListingSyncProActiveForAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsListingSyncProActiveResponse.fromProto(resp)));
    }
    createListingSyncProProviderSourceData(r) {
      const request = r.toApiJson ? r : new CreateListingSyncProProviderSourceDataRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/CreateListingSyncProProviderSourceData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getListingSyncProProviderSourcesData(r) {
      const request = r.toApiJson ? r : new GetListingSyncProProviderSourcesDataRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetListingSyncProProviderSourcesData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingSyncProProviderSourcesDataResponse.fromProto(resp)));
    }
    deleteListingSyncProProviderSource(r) {
      const request = r.toApiJson ? r : new DeleteListingSyncProProviderSourceRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/DeleteListingSyncProProviderSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getListingSyncProAddonId(r) {
      const request = r.toApiJson ? r : new GetListingSyncProAddonIdRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetListingSyncProAddonId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingSyncProAddonIdResponse.fromProto(resp)));
    }
    getScrapedSourceStatuses(r) {
      const request = r.toApiJson ? r : new GetScrapedSourceStatusesRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetScrapedSourceStatuses", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetScrapedSourceStatusesResponse.fromProto(resp)));
    }
    getListingData(r) {
      const request = r.toApiJson ? r : new GetListingDataRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetListingData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingDataResponse.fromProto(resp)));
    }
    getListingDataForATimePeriod(r) {
      const request = r.toApiJson ? r : new GetListingDataForATimePeriodRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetListingDataForATimePeriod", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingDataResponse.fromProto(resp)));
    }
    setSelectedSocialService(r) {
      const request = r.toApiJson ? r : new SetSelectedSocialServiceRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/SetSelectedSocialService", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetSelectedSocialServiceResponse.fromProto(resp)));
    }
    getSelectedSocialServices(r) {
      const request = r.toApiJson ? r : new GetSelectedSocialServicesRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetSelectedSocialServices", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSelectedSocialServicesResponse.fromProto(resp)));
    }
    getCitationsData(r) {
      const request = r.toApiJson ? r : new GetCitationDataRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetCitationsData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCitationDataResponse.fromProto(resp)));
    }
    getRawProviderSourcesForBusiness(r) {
      const request = r.toApiJson ? r : new GetProviderSourcesForBusinessRequest(r);
      return this.http.post(this._host + "/listing_sync_pro.v1.ListingSyncProService/GetRawProviderSourcesForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProviderSourcesForBusinessResponse.fromProto(resp)));
    }
  }
  ListingSyncProApiService.ɵfac = function ListingSyncProApiService_Factory(t) {
    return new (t || ListingSyncProApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ListingSyncProApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingSyncProApiService,
    factory: ListingSyncProApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingSyncProApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let ListingSyncProService = /*#__PURE__*/(() => {
  class ListingSyncProService {
    constructor(_api) {
      this._api = _api;
    }
    getListingSyncProAddonIds() {
      return this._api.listListingSyncProAddonIds({}).pipe(map(response => response.addonIds), catchError(() => {
        return of([]);
      }));
    }
    getListingSyncProAddonInfo() {
      return this._api.listListingSyncProAddonIds({}).pipe(map(response => response.addonInfo), catchError(() => {
        return of({});
      }));
    }
    getListingSyncProProviderSourcesData(provider, partnerId) {
      if (typeof provider === 'string') {
        provider = this.convertServiceProvider(provider);
      }
      return this._api.getListingSyncProProviderSourcesData({
        serviceProvider: provider,
        partnerId: partnerId
      }).pipe(map(response => response.sourceData), catchError(() => {
        return of({});
      }));
    }
    getListingSyncStatusesByBusinessID(businessId) {
      return this._api.listStatusesByBusiness({
        businessId
      }).pipe(map(response => response.sourceStatuses), catchError(() => {
        return of([]);
      }));
    }
    getListingSyncSources() {
      return this._api.listListingSyncProSources({
        serviceProviders: [ServiceProvider.SERVICE_PROVIDER_PROVIDER_0, ServiceProvider.SERVICE_PROVIDER_PROVIDER_1]
      }).pipe(map(response => response.sources), catchError(() => {
        return of({});
      }));
    }
    getScrapedSourceStatuses(businessId) {
      return this._api.getScrapedSourceStatuses({
        businessId
      }).pipe(map(response => response.sourceStatuses), catchError(() => {
        return of([]);
      }));
    }
    getListingData(businessId) {
      return this._api.getListingData({
        businessId
      }).pipe(map(response => response), catchError(() => {
        return of(new GetListingDataResponse({}));
      }));
    }
    listStatusesByPartner(partnerId, pagingOptions, searchTerm, filters) {
      return this._api.listStatusesByPartner({
        partnerId,
        pagingOptions,
        searchTerm,
        filters
      }).pipe(map(response => response), catchError(() => {
        return of(new ListStatusesByPartnerResponse({}));
      }));
    }
    convertServiceProvider(provider) {
      if (provider === 'PROVIDER_0') {
        return ServiceProvider.SERVICE_PROVIDER_PROVIDER_0;
      } else if (provider === 'PROVIDER_1') {
        return ServiceProvider.SERVICE_PROVIDER_PROVIDER_1;
      } else {
        return ServiceProvider.SERVICE_PROVIDER_UNSPECIFIED;
      }
    }
  }
  ListingSyncProService.ɵfac = function ListingSyncProService_Factory(t) {
    return new (t || ListingSyncProService)(i0.ɵɵinject(ListingSyncProApiService));
  };
  ListingSyncProService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingSyncProService,
    factory: ListingSyncProService.ɵfac,
    providedIn: 'root'
  });
  return ListingSyncProService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccountFilters, AccountListingStatuses, AccuracyStatus, ActivateListingSyncProRequest, AnchorData, AnchorDataMatches, BillingFrequency, Citation, CitationListing, CollectStatsRequest, CreateListingSyncProProviderSourceDataRequest, CreateListingSyncProSourceRequest, CreateListingSyncProSourceResponse, DeactivateListingSyncProRequest, DeleteListingSyncProProviderSourceRequest, DeleteStatsRequest, ErrorCode, Errors, GetAvailableProvidersForPartnerRequest, GetAvailableProvidersForPartnerResponse, GetCitationDataRequest, GetCitationDataResponse, GetListingDataForATimePeriodRequest, GetListingDataRequest, GetListingDataResponse, GetListingSyncProAddonIdRequest, GetListingSyncProAddonIdResponse, GetListingSyncProProviderSourcesDataRequest, GetListingSyncProProviderSourcesDataResponse, GetListingSyncProProviderSourcesDataResponseSourceDataEntry, GetProviderSourcesForBusinessRequest, GetProviderSourcesForBusinessResponse, GetScrapedSourceStatusesRequest, GetScrapedSourceStatusesResponse, GetSelectedSocialServicesRequest, GetSelectedSocialServicesResponse, HistoricalCitationsDataPoint, HistoricalScore, HostService, IsListingSyncProActiveRequest, IsListingSyncProActiveResponse, ListListingSyncProAddonIdsRequest, ListListingSyncProAddonIdsResponse, ListListingSyncProAddonIdsResponseAddonInfo, ListListingSyncProAddonIdsResponseAddonInfoBillingFrequency, ListListingSyncProAddonIdsResponseAddonInfoEntry, ListListingSyncProSourcesRequest, ListListingSyncProSourcesResponse, ListListingSyncProSourcesResponseSourcesEntry, ListStatusesByBusinessRequest, ListStatusesByBusinessResponse, ListStatusesByPartnerRequest, ListStatusesByPartnerResponse, ListingSyncProApiService, ListingSyncProProviderSourceData, ListingSyncProService, PagedRequestOptions, PagedResponseMetadata, ProcessListingSyncProMarketplaceActivationRequest, ProcessListingSyncProMarketplaceActivationRequestOrderFormDataEntry, ScoreData, SelectedSocialService, ServiceProvider, SetSelectedSocialServiceRequest, SetSelectedSocialServiceResponse, SiteType, SourceAccuracy, SourceData, SourceInfo, SourceInfoProviderSpecificIdsEntry, SourceStatus, SourceTableData, StatusCode, SyncingStatus };
